/**
 * Appends a querystring to a URL.
 *
 * @param {string} url A URL like 'http://www.anything.com' or 'anything.com?existingParam=someValue'.
 * @param {string} queryString A querystring like 'foo=bar' or 'skip=0&take=50' or '?something=whatever'
 * @return {string} A URL like 'anything.com?existingParam=someValue&something=whatever'
 */
export default (url: string, queryString: string) => {
	if (!queryString) {
		return url
	}
	const hasQueryString = url.indexOf('?') >= 0
	const finalQueryString = queryString.startsWith('?') ? queryString.substr(1) : queryString
	return url + (hasQueryString ? '&' : '?') + finalQueryString
}
